Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class OrganizationBoardsForMemberView extends View
  viewTitleKey: 'boards for member'
  viewTitleArguments: ->
    memberName: @model.get('fullName')

  initialize: ->
    @org = @options.parent
    return

  render: ->
    data = @model.toJSON()

    data.boards = @org.boardList.models
      .filter (board) => _.contains(board.memberList.models, @model) && board.isOpen()
      .map (board) =>
        b = board.toJSON()
        b.memberType = l(['member types', board.getMemberType(@model)])
        b.url = board.getUrl()
        return b

    @$el.html templates.fill('org_boards_for_member', data)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-boards-for-member-view.coffee